<template>
  <div class="carroussel" @mouseover="handleMouseOver">
    <div id="top">
      <h1 id="title">PORTFÓLIO</h1>

      <div class="out-item">
        <div class="around-arrow left-arrow">
          <div class="arrow" @click="goToBack">
            <img src="../../assets/seta-esquerda.png" alt="" />
          </div>
        </div>
        <div class="carroussel-item">
          <div class="carroussel-item-left">
            <div class="texts">
              <h2 class="title-transition">
                {{ currentSlide.title }}
              </h2>
              <p>
                {{ currentSlide.text }}
              </p>
            </div>
          </div>
          <img
            :src="require(`@/assets/servicos/${currentSlide.image}`)"
            class="carroussel-image"
          />
        </div>
        <div class="around-arrow right-arrow">
          <div class="arrow" @click="goToNext">
            <img src="../../assets/seta-direita.png" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div class="bottom">
      <Button
        class="button direct-button"
        :text="currentSlide.button"
        :link="currentLink"
        :target="tgt"
      />
      <div class="position-indicators" @click="stopCarroussel">
        <span
          v-for="(indicator, index) in indicators"
          :key="index"
          class="position-indicator"
          :class="{ active: index === currentSlideIndex }"
          @click="goToSlide(index)"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../../components/RedirectButton.vue";
import slidesJson from "./slides.json";

import Zmix from "../../assets/bombas/FT_ZMix.pdf";
import Zmag from "../../assets/bombas/FT_ZMag.pdf";
import Zprop from "../../assets/bombas/FT_ZProp.pdf";
import Vg37 from "../../assets/valvulas/FT_VG37.pdf";
import Vc38 from "../../assets/valvulas/FT_VC38.pdf";
import ValBorb from "../../assets/valvulas/FT_Válvula Borboleta.pdf";

export default {
  name: "Portfolio",
  components: {
    Button,
  },
  data() {
    return {
      slidesJson: slidesJson,
      currentSlideIndex: 0,
      IntervalID: null,
      hasBeenMouseOver: false,
      links: ["#contato", Zmix, Zmag, Zprop, Vg37, Vc38, ValBorb],
      indicators: [0, 1, 2, 3, 4, 5, 6],
    };
  },
  computed: {
    currentSlide() {
      return this.slidesJson[this.currentSlideIndex];
    },
    currentLink() {
      return this.links[this.currentSlideIndex];
    },
    tgt() {
      return this.currentSlideIndex == 0 ? "_self" : "_blank";
    },
  },
  methods: {
    handleMouseOver() {
      if (!this.hasBeenMouseOver) {
        this.rollCarroussel();
        this.hasBeenMouseOver = true;
      }
    },
    stopCarroussel() {
      clearInterval(this.IntervalID);
    },
    rollCarroussel() {
      this.IntervalID = setInterval(() => {
        if (this.currentSlideIndex == this.slidesJson.length - 1) {
          this.currentSlideIndex = 0;
        } else {
          this.currentSlideIndex = this.currentSlideIndex + 1;
        }
      }, 3000);
    },
    goToSlide(index) {
      this.currentSlideIndex = index;
    },
    goToNext() {
      if (this.currentSlideIndex == 6) {
        this.currentSlideIndex = 0;
      } else {
        this.currentSlideIndex++;
      }
      this.stopCarroussel();
    },
    goToBack() {
      if (this.currentSlideIndex == 0) {
        this.currentSlideIndex = 6;
      } else {
        this.currentSlideIndex--;
      }
      this.stopCarroussel();
    },
  },
};
</script>

<style scoped>
/* =============== Título =============== */

.carroussel {
  background-image: url("../../assets/BackgroundServicos.jpg");
  background-size: cover;
  background-repeat: no-repeat;

  height: 100vh;

  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

#title {
  color: #f5f5f5;
  font-family: "Montserrat", sans-serif;
  font-size: 3em;
  font-weight: 300;
  text-align: center;
  padding: 4vh 0 0 0;
}

#title::after {
  content: "";
  display: block;
  width: 2.3em;
  height: 0.09em;
  background-color: #ffc737;
  opacity: 0.8;
  border-radius: 30px;
  margin: 0.1em 0 0 0;
  margin-bottom: 15px;
  position: relative;
  left: 50%;
  top: 0;
  bottom: 0;
  transform: translateX(-50%);
}

/* =============== Slider =============== */

.out-item {
  height: 508px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-block: 2em 0 0 0;
}

.texts {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-right: 10px;
}

.carroussel-item {
  display: flex;
  align-items: center;
  margin-inline: 2em 0 0 0;
  justify-content: space-evenly;
  flex-direction: row;
  height: 100%;
}

.title-transition {
  color: white;
  text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.65);
  font-size: 3.8em;

  opacity: 1;
  transition: opacity 0.5s ease-in-out;
}

.carroussel-item-left {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  margin: 0 1.5em 0 0;
}

.carroussel-item-left p {
  color: white;
  font-size: 1.9em;
  font-weight: 400;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);

  text-align: left;

  margin: 2.2em 0 2.2em;
  max-height: 30vh;
}

.carroussel-image {
  max-width: 22vw;
  max-height: 35vh;
  padding: 2em 0 0 0;
}

.around-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.arrow {
  background-color: #ffc737;
  cursor: pointer;
  height: 50px;
  width: 35px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 3px;
  margin: 0 4em;
}

.arrow img {
  height: 2em;
  width: 2em;
}

.bottom {
  margin: 0 12vw;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.position-indicators {
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  padding: 3em 0 2.5em 0;
}

.position-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: gray;
  margin: 0 5px;
  cursor: pointer;
}

.position-indicator.active {
  background-color: #ffc737;
  width: 15px;
  height: 15px;
}

/* =============== Adicionando responsividade =============== */
@media screen and (max-width: 1260px) {
  .carroussel-image {
    max-height: 30vh;
  }

  .carroussel {
    min-height: 100vh;
  }

  .carroussel-item {
    margin: 1.5em 0 0 0;
  }
}

@media screen and (max-width: 1168px) {
  .carroussel-item {
    padding-bottom: 5vh;
    margin: 0;
    align-items: center;
    justify-content: center;

    margin: 5em 0 0 0;
  }

  .around-arrow {
    margin: 0 2em;
  }

  .carroussel-item-left {
    flex-direction: column;
  }

  .texts {
    align-items: center;
    justify-content: center;
  }

  .carroussel-item-left {
    margin: 0 0 2em 0;
  }

  .texts p {
    text-align: center;
    margin: 1em 0;
  }

  .carroussel-item-left p {
    font-size: 1.5em;
  }

  .carroussel-image {
    max-height: 25vh;
    max-width: 20vw;
  }

  .carroussel {
    height: 100vh;
  }

  .around-arrow {
    width: 10vw;
    height: 100%;
  }

  .carouussel-item {
    width: 80vw;
  }
}

@media screen and (max-width: 1024px) {
  .around-arrow {
    width: 68px;
  }
}

@media screen and (min-width: 950px) {
  .around-arrow {
    width: 68px;
  }
}

@media screen and (max-width: 992px) {
  .carroussel {
    height: 105vh;
  }

  .bottom {
    align-items: center;
    margin-bottom: 2vw;
  }

  .carroussel-image {
    padding: 0;
  }

  div.carroussel-item {
    flex-direction: column;
    justify-content: center;
    margin-top: 1em;
  }

  .title-transition {
    font-size: 2.7em;
  }

  div.carroussel-item-left {
    margin: 0 0 2em 0;
  }

  .arrow {
    margin: 0 1em;
  }
}

@media screen and (max-width: 624px) {
  #title {
    padding-bottom: 1em;
  }

  .carroussel {
    height: 110vw;
    width: 100vw;
  }

  .title-transition {
    font-size: 2em;
  }

  .texts {
    margin: 0;
  }

  .bottom {
    align-items: center;
  }

  .title-transition {
    letter-spacing: -2px;
  }

  .texts p {
    box-sizing: border-box;
    font-size: 1em;
    padding: 0 0 2em 0;
  }

  .carroussel-image {
    max-width: 40vw;
    padding: 0 0 2em 0;
    margin: 2em 0 0 0;
  }

  .carroussel-item {
    flex: 4;
    width: 60vw;
    max-height: 30vw;
    justify-content: space-between;
  }

  .around-arrow {
    flex: 3;
    display: flex;
    justify-content: center;
    width: 20vw;
    padding: 2em;
    margin: 0 0.5em;
    height: 100%;
    padding: 0;
  }

  .out-item {
    max-height: 30vw;
    max-width: 100vw;
    margin-top: 30vw;
  }

  .arrow {
    margin: 0;
  }

  .carroussel {
    justify-content: space-between;
  }

  .position-indicators {
    padding: 1.2em 0 1.2em 0;
  }

  /* .left-arrow {
    padding-right: 0;
    margin-right: 0;
  }
  .right-arrow {
    padding-left: 0;
    margin-left: 0;
  } */
}

@media screen and (max-width: 500px) {
  .out-item {
    margin-top: 45vw;
  }
}

@media screen and (max-width: 400px) {
  .out-item {
    margin-top: 50vw;
  }
}

@media screen and (max-width: 340px) {
  .texts p {
    font-size: 0;
  }
}

@media screen and (max-height: 768px) {
  .out-item {
    margin-top: 25vw;
    height: 25vw;
  }

  #title {
    color: transparent;
  }

  #title::after {
    width: 0;
  }
}

@media screen and (max-height: 624px) {
  .texts p {
    font-size: 0;
  }

  .out-item {
    margin-top: 10vw;
    height: 10vw;
  }
}

@media screen and (max-height: 476px) {
  .direct-button {
    font-size: 10px;
  }

  .position-indicator {
    width: 5px;
    height: 5px;
  }

  .position-indicator.active {
    width: 8px;
    height: 8px;
  }
}
</style>